export default __webpack_public_path__ + "static/media/lion-logo.4d5e3fd6.jpg";